import { myAxios } from "./helper";
import { toast } from "react-toastify";
// 1. Generate token for employee (calls backend)
export const generateEmployeeToken = (loginDetails) => {
  return myAxios
    .post("/employee/generate-token", loginDetails)
    .then((res) => {
      return { token: res.data.token }; // ✅ Use .token because backend returns { token: "..." }
    });
};

// 2. Store token
export const loginEmployee = (token) => {
  localStorage.setItem("employeeToken", token);
};

// 3. Get token
export const getEmployeeToken = () => {
  return localStorage.getItem("employeeToken");
};

// 4. Remove token
export const logoutEmployee = () => {
  localStorage.removeItem("employeeToken");
};

// 5. Get current employee
export const getCurrentEmployee = () => {
  const token = getEmployeeToken();
  return myAxios.get("/employee/current-user", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// 6. Store employee object
export const setEmployee = (employee) => {
  localStorage.setItem("employee", JSON.stringify(employee));
};


export const getMyProfile = async () => {
  const token = getEmployeeToken();
  try {
    const response = await myAxios.get("/employee/profile", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    toast.error("Failed to load profile");
    throw error;
  }
};

export const updateMyProfile = async (updatedData) => {
  const token = getEmployeeToken();
  try {
    const response = await myAxios.put("/employee/profile", updatedData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    toast.success("Profile updated successfully");
    return response.data;
  } catch (error) {
    toast.error("Failed to update profile");
    throw error;
  }
};